/*
 * jQuery retina cover plugin
 */
(function ($) {
  const styleRules = {};
  const templates = {
    '2x': [
      '(-webkit-min-device-pixel-ratio: 1.5)',
      '(min-resolution: 192dpi)',
      '(min-device-pixel-ratio: 1.5)',
      '(min-resolution: 1.5dppx)',
    ],
    '3x': [
      '(-webkit-min-device-pixel-ratio: 3)',
      '(min-resolution: 384dpi)',
      '(min-device-pixel-ratio: 3)',
      '(min-resolution: 3dppx)',
    ],
  };

  function addSimple(imageSrc, media, id) {
    const style = buildRule(id, imageSrc);

    addRule(media, style);
  }

  function addRetina(imageData, media, id) {
    const currentRules = templates[imageData[1]].slice();
    let patchedRules = currentRules;
    const style = buildRule(id, imageData[0]);

    if (media !== 'default') {
      patchedRules = $.map(currentRules, (ele, i) => `${ele} and ${media}`);
    }

    media = patchedRules.join(',');

    addRule(media, style);
  }

  function buildRule(id, src) {
    return `#${id}{background-image: url("${src}");}`;
  }

  function addRule(media, rule) {
    const $styleTag = styleRules[media];
    let styleTagData;
    let rules = '';

    if (media === 'default') {
      rules = `${rule} `;
    } else {
      rules = `@media ${media}{${rule}}`;
    }

    if (!$styleTag) {
      styleRules[media] = $('<style>').text(rules).appendTo('head');
    } else {
      styleTagData = $styleTag.text();
      styleTagData = `${styleTagData.substring(0, styleTagData.length - 2)} }${rule}}`;
      $styleTag.text(styleTagData);
    }
  }

  $.fn.retinaCover = function () {
    return this.each(function () {
      const $block = $(this);
      const $items = $block.children('[data-srcset]');
      const id = `bg-stretch${Date.now()}${(Math.random() * 1000).toFixed(0)}`;

      if ($items.length) {
        $block.attr('id', id);

        $items.each(function () {
          const $item = $(this);
          const data = $item.data('srcset').split(', ');
          const media = $item.data('media') || 'default';
          const dataLength = data.length;
          let itemData;
          let i;

          for (i = 0; i < dataLength; i++) {
            itemData = data[i].split(' ');

            if (itemData.length === 1) {
              addSimple(itemData[0], media, id);
            } else {
              addRetina(itemData, media, id);
            }
          }
        });
      }

      $items.detach();
    });
  };
}(jQuery));
